import { pushEvent } from 'src/client/data-layer';

export const trackPopularSearchesListed = () => {
  pushEvent('popularSearchesListed');
};

export const trackPopularSearchClicked = (value: string) => {
  pushEvent('popularSearchClicked', {
    value,
  });
};
